<template>
    <div
        :class="[
            'progress-orbs',
            props.content.showValidation.value && 'progress-orbs--validation',
            props.content.showArrow.value && 'progress-orbs--show-arrow',
            props.content.showBorder.value && 'progress-orbs--border',
        ]"
    >
        <template
            v-for="index in totalQuestions"
            :key="index"
        >
            <div
                :class="[
                    'progress-orbs-item',
                    isChecked(index) && 'progress-orbs-item--checked',
                    isActive(index) && 'progress-orbs-item--active',
                ]"
            >
                <div class="orb">
                    <div
                        v-if="props.content.showNumber.value"
                        class="orb__number"
                    >
                        {{ index }}
                    </div>
                </div>

                <div
                    v-if="props.content.showArrow.value"
                    class="progress-orbs-item__arrow"
                />
            </div>

            <div
                v-if="props.content.showDivider.value && index !== totalQuestions"
                class="progress-orbs-divider"
            />
        </template>
    </div>
</template>

<script setup>
import {computed, onMounted} from 'vue';
import { useStore } from 'vuex';
import { componentProps } from '../../../../../mixins/component/component';
import {get} from '../../../../../../../resources/frontend/js/mixins/get-page-data';

const store = useStore();

const props = defineProps({
    ...componentProps,
    totalQuestionsOverwrite: {
        type: Number,
        default: null,
    },
    continuousFlowLength: {
        type: Number,
        default: null,
    },
});

const totalQuestions = computed(() => {
    if (props.totalQuestionsOverwrite) return props.totalQuestionsOverwrite;
    if (props.continuousFlowLength) return props.continuousFlowLength;
    return store.state.quiz.totalFlowLength;
});

const isChecked = index => {
    const isContinuousFlow = store.state.quiz.continuousFlow;

    if (isContinuousFlow) {
        const formStep = store.state.form.attributes.step;
        return index < store.state.quiz.questionCount + formStep - 1;
    }

    return index < store.state.quiz.questionCount;
};

const isActive = index => {
    const isContinuousFlow = store.state.quiz.continuousFlow;

    if (isContinuousFlow) {
        const formStep = store.state.form.attributes.step;
        return index === store.state.quiz.questionCount + formStep - 1;
    }

    return index === store.state.quiz.questionCount;
};
</script>

<style lang="scss" scoped>
@use 'zoe-molecule-progress-orbs';

.progress-orbs {
    --border-color: v-bind('props.content.style.borderColor.value');
    --arrow-color: v-bind('props.content.style.arrowColor.value');
    --orb-number-color: v-bind('props.content.style.orbNumberColor.value');
    --orb-background: v-bind('props.content.style.orbBackground.value');
    --orb-active-number-color: v-bind('props.content.style.orbActiveNumberColor.value');
    --orb-active-background: v-bind('props.content.style.orbActiveBackground.value');
}
</style>
